<script>
  import { API_BASE_URL } from './config.js';
  import Button from './components/common/Button.svelte';
  import BaseModal from './components/modals/BaseModal.svelte';
  import FileUpload from './components/common/FileUpload.svelte';
  import InfoModal from './components/modals/InfoModal.svelte';
  
  export let setPage;
  
  // 약관 내용
  const TERMS_OF_SERVICE = `제 1 장 총칙

제 1 조 (목적)
본 약관은 주식회사 비전와이드에서 운영하는 웹 사이트(https://www.visionwide.kr)의 제반 서비스의 이용조건 및 절차에 관한 사항 및 기타 필요한 사항을 규정함을 목적으로 한다.

제 2 조 (용어의 정의)
본 약관에서 사용하는 용어는 다음과 같이 정의한다.
①회원 : 기본 회원 정보를 입력하였고, 회사와 서비스 이용계약을 체결하여 아이디를 부여받은 개인
②아이디(ID) : 회원식별과 회원의 서비스 이용을 위해 회원이 선정하고 회사가 승인하는 문자와 숫자의 조합
③비밀번호(Password) : 회원이 통신상의 자신의 비밀을 보호하기 위해 선정한 문자와 숫자의 조합
④해지 : 회사 또는 회원에 의한 이용계약의 종료

제 3 조 (약관의 공시 및 효력과 변경)
①본 약관은 회원가입 화면에 게시하여 공시하며 회사는 사정변경 및 영업상 중요한 사유가 있을 경우 약관을 변경할 수 있으며 변경된 약관은 공지사항을 통해 공시한다
②본 약관 및 차후 회사사정에 따라 변경된 약관은 이용자에게 공시함으로써 효력을 발생한다.

제 4 조 (약관 외 준칙)
본 약관에 명시되지 않은 사항이 전기통신기본법, 전기통신사업법, 정보통신촉진법, '전자상거래등에서의 소비자 보호에 관한 법률', '약관의 규제에관한법률', '전자거래기본법', '전자서명법', '정보통신망 이용촉진등에 관한 법률', '소비자보호법' 등 기타 관계 법령에 규정되어 있을 경우에는 그 규정을 따르도록 한다.

제 2 장 이용계약

제 5 조 (이용신청)
①이용신청자가 회원가입 안내에서 본 약관과 개인정보보호정책에 동의하고 등록절차(회사의 소정 양식의 가입 신청서 작성)를 거쳐 '확인' 버튼을 누르면 이용신청을 할 수 있다.
②이용신청자는 반드시 실명과 실제 정보를 사용해야 하며 1개의 생년월일에 대하여 1건의 이용신청을 할 수 있다.
③실명이나 실제 정보를 입력하지 않은 이용자는 법적인 보호를 받을 수 없으며, 서비스 이용에 제한을 받을 수 있다.

제 6 조 (이용신청의 승낙)
①회사는 제5조에 따른 이용신청자에 대하여 제2항 및 제3항의 경우를 예외로 하여 서비스 이용을 승낙한다.
②회사는 아래 사항에 해당하는 경우에 그 제한사유가 해소될 때까지 승낙을 유보할 수 있다.
가. 서비스 관련 설비에 여유가 없는 경우
나. 기술상 지장이 있는 경우
다. 기타 회사 사정상 필요하다고 인정되는 경우
③회사는 아래 사항에 해당하는 경우에 승낙을 하지 않을 수 있다.
가. 다른 사람의 명의를 사용하여 신청한 경우
나. 이용자 정보를 허위로 기재하여 신청한 경우
다. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우
라. 기타 회사가 정한 이용신청 요건이 미비한 경우

제 3 장 계약 당사자의 의무

제 7 조 (회사의 의무)
①회사는 사이트를 안정적이고 지속적으로 운영할 의무가 있다.
②회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정될 경우에는 즉시 처리해야 한다. 단, 즉시 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 공지사항 또는 전자우편을 통해 통보해야 한다.
③제1항의 경우 수사상의 목적으로 관계기관 및 정보통신윤리위원회의 요청이 있거나 영장 제시가 있는 경우, 기타 관계 법령에 의한 경우는 예외로 한다.

제 8 조 (이용자의 의무)
①이용자는 본 약관 및 회사의 공지사항, 사이트 이용안내 등을 숙지하고 준수해야 하며 기타 회사의 업무에 방해되는 행위를 해서는 안된다.
②이용자는 회사의 사전 승인 없이 본 사이트를 이용해 어떠한 영리행위도 할 수 없다.
③이용자는 본 사이트를 통해 얻는 정보를 회사의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 및 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없다.

제 4 장 서비스의 제공 및 이용

제 9 조 (서비스 이용)
①이용자는 본 약관의 규정된 사항을 준수해 사이트를 이용한다.
②본 약관에 명시되지 않은 서비스 이용에 관한 사항은 회사가 정해 '공지사항'에 게시하거나 또는 별도로 공지하는 내용에 따른다.

제 10 조 (정보의 제공)
회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보에 대하여 전자메일이나 서신우편 등의 방법으로 회원에게 정보를 제공할 수 있다.

제 11 조 (광고게재)
①회사는 서비스의 운용과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고 등을 게재할 수 있다.
②회사는 사이트에 게재되어 있는 광고주의 판촉활동에 회원이 참여하거나 교신 또는 거래의 결과로서 발생하는 모든 손실 또는 손해에 대해 책임을 지지 않는다.

제 12 조 (서비스 이용의 제한)
본 사이트 이용 및 행위가 다음 각 항에 해당하는 경우 회사는 해당 이용자의 이용을 제한할 수 있다.
①공공질서 및 미풍양속, 기타 사회질서를 해하는 경우
②범죄행위를 목적으로 하거나 기타 범죄행위와 관련된다고 객관적으로 인정되는 경우
③타인의 명예를 손상시키거나 타인의 서비스 이용을 현저히 저해하는 경우
④타인의 의사에 반하는 내용이나 광고성 정보 등을 지속적으로 전송하는 경우
⑤해킹 및 컴퓨터 바이러스 유포 등으로 서비스의 건전한 운영을 저해하는 경우
⑥다른 이용자 또는 제3자의 지적재산권을 침해하거나 지적재산권자가 지적 재산권의 침해를 주장할 수 있다고 판단되는 경우
⑦타인의 아이디 및 비밀번호를 도용한 경우
⑧기타 관계 법령에 위배되는 경우 및 회사가 이용자로서 부적당하다고 판단한 경우

제 13 조 (서비스 제공의 중지)
회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부의 제공을 중지할 수 있다.
①전기통신사업법 상에 규정된 기간통신 사업자 또는 인터넷 망 사업자가 서비스를 중지했을 경우
②정전으로 서비스 제공이 불가능할 경우
③설비의 이전, 보수 또는 공사로 인해 부득이한 경우
④서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 제공이 어려운 경우
⑤전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우

제 14 조 (게시물 관리)
회사는 건전한 통신문화 정착과 효율적인 사이트 운영을 위하여 이용자가 게시하거나 제공하는 자료가 제12조에 해당한다고 판단되는 경우에 임의로 삭제, 자료이동, 등록거부를 할 수 있다.

제 15 조 (서비스 이용 책임)
이용자는 회사에서 권한 있는 사원이 서명한 명시적인 서면에 구체적으로 허용한 경우를 제외하고는 서비스를 이용하여 불법상품을 판매하는 영업활동을 할 수 없으며 특히 해킹, 돈벌기 광고, 음란 사이트를 통한 상업행위, 상용 S/W 불법제공 등을 할 수 없다. 이를 어기고 발생한 영업활동의 결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등에 관해서는 회사가 책임을 지지 않는다.

제 5 장 (재화의 주문 및 결제 관련)

제16조 (결제방법)
'회원'은 '회사'에서 판매하는 재화에 대하여 '선불카드, 직불카드, 신용카드 등의 각종 카드 결제 수단'을 이용하여 결제할 수 있다. 이때 '회사'는 이용자의 지급방법에 대하여 재화외 어떠한 명목의 수수료를 추가 징수하지 않는다.
① '회사'는 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 한다. 주문확인에 대한 내용은 해당게시판에서 확인 할 수 있다.
② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 '회사'는 배송전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리한다. 다만 이미 대금을 지불한 경우에는 제18조의 '반품규정'을 따른다.

제17조 (배송정책)
① '회사'는 이용자와 재화의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 결재를 실시한 날부터 7일 이내에 재화 등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취한다.
②'회사'는 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 제품을 구매하는 웹 페이지 하단에 명시한다. 만약 '회사'가 약정 배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상한다. 하지만 '회사'의 고의과실이 없음을 입증한 경우에는 그러하지 아니한다.

18조 (취소 및 반품 환불 규정)
'회사'는 이용자가 구매 신청한 재화 등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 한다.
① 재화가 발송 되기전 이용자가 결제를 취소할 경우 '회사'는 해당 주문건을 취소 처리하고 카드결제 승인을 취소한다.
② 재화가 발송 된 이후 결제 취소는 불가하다. 단, '회사'의 부주의 '배송'상의 문제로 인한 재화의 파손, 변질의 경우 '회사'는 이용자에게 구매 금액의 반품 및 환불 조취 및 교환 조취를 취한다.

제 6 장 기타

제 19 조 (면책 및 손해배상)
①천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 회사의 서비스 제공 책임이 면제된다.
②회사는 이용자간 또는 이용자와 제3자간의 상호거래 관계에서 발생되는 결과에 대하여 어떠한 책임도 부담하지 않는다.
③회사는 이용자가 게시판에 게재한 정보, 자료, 내용 등에 관하여 사실의 정확성, 신뢰도 등에 어떠한 책임도 부담하지 않으며 이용자는 본인의 책임 아래 본 사이트를 이용해야 한다.
④이용자가 게시 또는 전송한 자료 등에 관하여 손해가 발생하거나 자료의 취사선택, 기타 무료로 제공되는 서비스 이용과 관련해 어떠한 불이익이 발생하더라도 이에 대한 모든 책임은 이용자에게 있다.
⑤아이디와 비밀번호의 관리 및 이용자의 부주의로 인하여 발생되는 손해 또는 제3자에 의한 부정사용 등에 대한 책임은 이용자에게 있다.
⑥이용자가 본 약관의 규정을 위반함으로써 회사에 손해가 발생하는 경우 이 약관을 위반한 이용자는 회사에 발생한 모든 손해를 배상해야 하며 동 손해로부터 회사를 면책시켜야 한다.

제 20 조 (개인신용정보 제공 및 활용에 대한 동의서)
회사가 회원 가입과 관련해 취득한 개인 신용 정보는 신용정보의 이용 및 보호에 관한 법률 제23조의 규정에 따라 타인에게 제공 및 활용 시 이용자의 동의를 얻어야 한다. 이용자의 동의는 회사가 회원으로 가입한 이용자의 신용정보를 신용정보기관, 신용정보업자 및 기타 이용자 등에게 제공해 이용자의 신용을 판단하기 위한 자료로서 활용하거나 공공기관에서 정책자료로 활용하는데 동의하는 것으로 간주한다.

제 21 조 (분쟁의 해결)
①회사와 이용자는 본 사이트 이용과 관련해 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 해야 한다.
②제1항의 규정에도 불구하고 동 분쟁으로 인하여 소송이 제기될 경우 동 소송은 회사의 본사 소재지를 관할하는 법원의 관할로 본다.

<부칙>
본 약관은 2025년 7월 1일부터 적용한다.

`;

  const PRIVACY_POLICY = `1. 개인정보의 처리 목적
주식회사 비전와이드('https://www.visionwide.kr' 이하 '비전와이드 웹 사이트')은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.

가. 홈페이지 회원가입 및 관리
각종 고지·통지, 고충처리, 입사지원관련 등을 목적으로 개인정보를 처리합니다.

나. 민원사무 처리
민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다.

2. 개인정보 파일 현황
- 개인정보 파일명 : '비전와이드 웹 사이트' 개인정보처리방침
- 개인정보 항목 : 자택주소, 비밀번호, 생년월일, 자택전화번호, 휴대전화번호, 이름, 이메일, 접속 IP 정보
- 수집방법 : 홈페이지
- 보유근거 : 관련법령의거
- 보유기간 : 3년
- 관련법령 : 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년, 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년

3. 개인정보처리 위탁

① '비전와이드 웹 사이트'은(는) 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
② '비전와이드 웹 사이트'은(는) 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리?감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.

4. 정보주체의 권리,의무 및 그 행사방법 이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.

① 정보주체는 '비전와이드 웹 사이트' 에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.

1. 개인정보 열람요구
2. 오류 등이 있을 경우 정정
3. 삭제요구
4. 처리정지 요구

② 제1항에 따른 권리 행사는'비전와이드 웹 사이트'에 대해 개인정보 보호법 시행규칙 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 '비전와이드 웹 사이트'은(는) 이에 대해 지체 없이 조치하겠습니다.
③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 '비전와이드 웹 사이트' 은(는) 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.

5. 처리하는 개인정보의 항목 작성

① '비전와이드 웹 사이트' 은(는) 다음의 개인정보 항목을 처리하고 있습니다.

<홈페이지 회원가입 및 관리>
- 필수항목 : 개인정보의 처리 목적, 개인정보파일 현황, 개인정보의 처리 및 보유 기간, 정보주체의 권리·의무 및 그 행사방법에 관한 사항, 처리하는 개인정보의 항목, 개인정보의 파기에 관한 사항, 개인정보 보호책임자에 관한 사항, 개인정보 처리방침의 변경에 관한 사항, 개인정보의 안전성 확보조치에 관한 사항
- 선택항목 : 없음

6. 개인정보의 파기

'비전와이드 웹 사이트' 은(는) 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.

-파기절차
이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.

-파기기한
이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.

-파기방법
전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.

7. 개인정보의 안전성 확보 조치

'비전와이드 웹 사이트' 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.

1. 개인정보 취급 직원의 최소화 및 교육
개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.

2. 정기적인 자체 감사 실시
개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.

3. 내부관리계획의 수립 및 시행
개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.

4. 개인정보의 암호화
이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.

5. 해킹 등에 대비한 기술적 대책
'비전와이드 웹 사이트'은 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.

6. 개인정보에 대한 접근 제한
개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.

7. 접속기록의 보관 및 위변조 방지
개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.

8. 비인가자에 대한 출입 통제
개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.

8. 개인정보 보호책임자 작성

① '비전와이드 웹 사이트'은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자
성명 : 최병영
직급 : 대표이사
연락처 : master@visionwide.kr
※ 개인정보 보호 담당부서로 연결됩니다.

▶ 개인정보 보호 담당부서
부서명 : 개인정보보호실
연락처 : admin@visionwide.kr

② 정보주체께서는 '비전와이드 웹 사이트'의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. '비전와이드 웹 사이트'은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.

9. 개인정보 처리방침 변경

①이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.

`;

  const MARKETING_CONSENT = `비전와이드 채용 사이트의 이벤트・혜택 등의 정보 발송을 위해 성명, 아이디, 휴대전화번호, 이메일주소를 수집합니다.

성명, 아이디, 휴대전화번호, 이메일주소는 네이버 서비스 제공을 위한 필수 수집항목으로서 회원 가입 기간 동안 보관하나, 이벤트 혜택 정보 수신 동의를 철회하시면 본 목적으로의 개인정보 처리는 중지됩니다.
정보주체는 개인정보 수집 및 이용 동의를 거부하실 수 있으며, 미동의 시에도 서비스 이용은 가능합니다.

※ 일부 서비스의 경우, 수신에 대해 별도로 안내 드리며, 동의를 구합니다.

`;
  
  // 상태 변수
  let step = 1; // 1: 약관동의, 2: 정보입력, 3: 가입완료
  let acceptTerms = false;
  let acceptPrivacy = false;
  let acceptMarketing = false;
  let isLoading = false;
  let errorMessage = '';
  let showModal = false;
  let modalTitle = '';
  let modalContent = '';
  
  // 약관 확인 상태
  let termsViewed = false;
  let privacyViewed = false;
  
  // 회원 정보 입력값
  let email = '';
  let password = '';
  let passwordConfirm = '';
  let name = '';
  let phone = '';
  let birthDate = ''; // age에서 birthDate로 변경
  let calculatedAge = ''; // 자동 계산된 나이
  let gender = '';
  let educationLevel = ''; // 최종학력 (필수 기재)
  let careerYear = 0; // 경력년차 (기본값: 0년)
  let careerMonth = 0; // 경력월차 (기본값: 0개월)
  let region = '';
  let memberType = 'individual';
  let availableFrom = ''; // 투입가능일자
  let isEmailDuplicated = false; // 이메일 중복 확인 상태

  // 주소 관련 변수
  let zipcode = ''; // 우편번호
  let basicAddress = ''; // 기본주소
  let detailAddress = ''; // 상세주소

  // 추천자 이메일
  let recommenderEmail = '';
  
  // 파일 업로드 관련 상태 (3단계에서 사용)
  let uploadedFiles = [];
  let isFileUploading = false;
  let newUser = null; // 회원가입 성공 후 사용자 정보 저장
  
  // 커스텀 알럿 모달 상태
  let alertOpen = false;
  let alertMessage = '';
  let alertType = 'warning';
  
  // 알럿 모달 표시 함수
  function showAlert(message, type = 'warning') {
    alertMessage = message;
    alertType = type;
    alertOpen = true;
  }

  // 다음 주소 API 호출 함수
  function openDaumPostcode() {
    if (typeof window.daum === 'undefined' || typeof window.daum.Postcode === 'undefined') {
      // 다음 주소 API 스크립트가 로드되지 않은 경우 동적으로 로드
      const script = document.createElement('script');
      script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      script.onload = () => {
        setTimeout(openDaumPostcode, 100); // 스크립트 로드 후 재호출
      };
      document.head.appendChild(script);
      return;
    }

    new window.daum.Postcode({
      oncomplete: function(data) {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분입니다.

        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        let addr = ''; // 주소 변수
        let extraAddr = ''; // 참고항목 변수

        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
          addr = data.roadAddress;
        } else { // 사용자가 지번 주소를 선택했을 경우(J)
          addr = data.jibunAddress;
        }

        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
        if(data.userSelectedType === 'R'){
          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
            extraAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if(data.buildingName !== '' && data.apartment === 'Y'){
            extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
          }
          // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if(extraAddr !== ''){
            extraAddr = ' (' + extraAddr + ')';
          }
          // 조합된 참고항목을 해당 필드에 넣는다.
          addr += extraAddr;
        }

        // 우편번호와 주소 정보를 필드에 넣는다.
        zipcode = data.zonecode;
        basicAddress = addr;

        // 커서를 상세주소 필드로 이동한다.
        setTimeout(() => {
          const detailAddressInput = document.getElementById('detail-address');
          if (detailAddressInput) {
            detailAddressInput.focus();
          }
        }, 100);
      },
      // 우편번호 검색 후 주소 클릭 시 닫힘
      onclose: function(state) {
        //state를 이용하여 팝업이 닫힐 때의 상태를 확인할 수 있다.
        if (state === 'FORCE_CLOSE'){
          //사용자가 ESC를 눌러 팝업을 닫았을 경우
          //예를 들어, validation 로직 추가 가능
        } else if (state === 'COMPLETE_CLOSE'){
          //사용자가 주소를 선택하여 팝업이 닫혔을 경우
          //상세주소 필드로 포커스 이동은 이미 oncomplete에서 처리됨
        }
      }
    }).open({
      popupName: 'postcodePopup',
      popupKey: 'popup1' // 팝업창 Key 값 설정 (여러개의 팝업을 띄울 경우 중복되지 않게 설정)
    });
  }
  
  // 생년월일로부터 나이 계산
  function calculateAge(birthDateString) {
    if (!birthDateString) {
      calculatedAge = '';
      return;
    }
    
    const today = new Date();
    const birthDate = new Date(birthDateString);
    
    if (birthDate > today) {
      calculatedAge = '';
      return;
    }
    
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    calculatedAge = age.toString();
  }
  
  // 생년월일 변경 시 나이 자동 계산
  $: if (birthDate) {
    calculateAge(birthDate);
  }
  
  // errorMessage 값이 설정되면 커스텀 알럿으로 표시 후 초기화
  $: if (errorMessage) {
    showAlert(errorMessage, 'warning');
    errorMessage = '';
  }
  
  // 전체 약관 동의/해제 토글
  function toggleAllAgreements(checked) {
    if (checked) {
      // 전체 동의 시 필수 약관 확인 여부 체크
      if (!termsViewed || !privacyViewed) {
        errorMessage = '필수 약관을 먼저 확인해주세요.';
        return;
      }
      errorMessage = '';
    }
    
    acceptTerms = checked && termsViewed;
    acceptPrivacy = checked && privacyViewed;
    acceptMarketing = checked;
  }
  
  // 약관 모달 표시
  function showTermsModal(type) {
    switch (type) {
      case 'terms':
        modalTitle = '서비스 이용약관';
        modalContent = TERMS_OF_SERVICE;
        termsViewed = true;
        break;
      case 'privacy':
        modalTitle = '개인정보 수집 및 이용 동의';
        modalContent = PRIVACY_POLICY;
        privacyViewed = true;
        break;
      case 'marketing':
        modalTitle = '마케팅 정보 수신 동의';
        modalContent = MARKETING_CONSENT;
        break;
    }
    showModal = true;
  }
  
  // 약관 동의 처리
  function handleTermsCheck(type, checked) {
    if (checked) {
      if (type === 'terms' && !termsViewed) {
        errorMessage = '서비스 이용약관을 먼저 확인해주세요.';
        return false;
      } else if (type === 'privacy' && !privacyViewed) {
        errorMessage = '개인정보 수집 및 이용 동의를 먼저 확인해주세요.';
        return false;
      }
      errorMessage = '';
    }
    return checked;
  }
  
  // 모달 닫기
  function closeModal() {
    showModal = false;
    modalTitle = '';
    modalContent = '';
  }
  
  // 다음 단계로 진행
  function goToNextStep() {
    if (step === 1) {
      // 필수 약관 동의 확인
      if (!acceptTerms || !acceptPrivacy) {
        errorMessage = '필수 약관에 모두 동의해주세요.';
        return;
      }
      errorMessage = '';
      step = 2;
    } else if (step === 2) {
      // 회원 정보 유효성 검사
      if (!validateForm()) {
        return;
      }
      // 회원가입 요청 보내기
      handleSignup();
    }
  }
  
  // 이전 단계로 돌아가기
  function goToPrevStep() {
    if (step > 1) {
      step--;
      errorMessage = '';
    } else {
      setPage('login');
    }
  }
  
  // 이메일 중복 확인
  async function checkEmailDuplicate() {
    if (!email) {
      errorMessage = '이메일을 입력해주세요.';
      return;
    }
    
    try {
      isLoading = true;
      
      const response = await fetch(`${API_BASE_URL}/api/check-email?email=${encodeURIComponent(email)}`, {
        method: 'GET'
      });
      
      const data = await response.json();
      
      if (response.ok) {
        isEmailDuplicated = true;
        errorMessage = '';
        alert('사용 가능한 이메일입니다.');
      } else {
        isEmailDuplicated = false;
        errorMessage = data.error || '이미 사용 중인 이메일입니다.';
      }
    } catch (error) {
      console.error('이메일 확인 오류:', error);
      errorMessage = '서버 연결에 실패했습니다.';
      isEmailDuplicated = false;
    } finally {
      isLoading = false;
    }
  }
  
  
  // 폼 유효성 검사
  function validateForm() {
    // 이메일 검증
    if (!email) {
      errorMessage = '이메일을 입력해주세요.';
      return false;
    }

    // 이메일 중복 확인 여부
    if (!isEmailDuplicated) {
      errorMessage = '이메일 중복 확인을 해주세요.';
      return false;
    }

    // 이메일 형식 검증
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      errorMessage = '유효한 이메일 형식이 아닙니다.';
      return false;
    }
    
    // 비밀번호 검증
    if (!password) {
      errorMessage = '비밀번호를 입력해주세요.';
      return false;
    }
    
    // 비밀번호 패턴 검증 (영문, 숫자, 특수문자 포함 8~20자)
    const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/;
    if (!passwordPattern.test(password)) {
      errorMessage = '비밀번호는 영문, 숫자, 특수문자를 포함한 8~20자리여야 합니다.';
      return false;
    }
    
    // 비밀번호 확인 일치 여부
    if (password !== passwordConfirm) {
      errorMessage = '비밀번호가 일치하지 않습니다.';
      return false;
    }
    
    // 이름 검증
    if (!name) {
      errorMessage = '이름을 입력해주세요.';
      return false;
    }
    
    // 생년월일 검증
    if (!birthDate) {
      errorMessage = '생년월일을 입력해주세요.';
      return false;
    }
    
    // 생년월일 형식 검증 (미래 날짜 불가)
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    
    if (birthDateObj > today) {
      errorMessage = '미래 날짜는 입력할 수 없습니다.';
      return false;
    }
    
    // 나이 범위 검증 (자동 계산된 나이 기준)
    if (!calculatedAge || parseInt(calculatedAge) < 14 || parseInt(calculatedAge) > 100) {
      errorMessage = '나이는 14세 이상 100세 이하여야 합니다.';
      return false;
    }
    
    // 성별 검증
    if (!gender) {
      errorMessage = '성별을 선택해주세요.';
      return false;
    }
    
    // 주소 검증 (우편번호 또는 기본주소가 있는 경우)
    if ((zipcode && !basicAddress) || (!zipcode && basicAddress)) {
      errorMessage = '주소 찾기 버튼을 눌러 정확한 주소를 입력해주세요.';
      return false;
    }
    
    // 전화번호 검증
    if (!phone) {
      errorMessage = '휴대폰 번호를 입력해주세요.';
      return false;
    }
    
    // 전화번호 형식 검증 (숫자만)
    if (!/^\d+$/.test(phone)) {
      errorMessage = "'-' 없이 숫자만 입력해주세요.";
      return false;
    }
    
    // 투입가능일자 검증 - 주석 처리
    // if (!availableFrom) {
    //   errorMessage = '투입가능일자를 입력해주세요.';
    //   return false;
    // }

    // 투입가능일자 형식 검증 (미래 날짜여야 함) - 주석 처리
    // const todayForAvailable = new Date();
    // const availableDate = new Date(availableFrom);

    // if (availableDate < todayForAvailable) {
    //   errorMessage = '투입가능일자는 오늘 이후 날짜여야 합니다.';
    //   return false;
    // }

    // 최종학력 검증
    if (!educationLevel || !['highschool', 'associate', 'bachelor', 'master'].includes(educationLevel)) {
      errorMessage = '올바른 최종학력을 선택해주세요.';
      return false;
    }

    // 경력년차 검증 (0 이상의 정수)
    if (careerYear < 0 || careerYear > 50) {
      errorMessage = '경력년차는 0년 이상 50년 이하로 입력해주세요.';
      return false;
    }
    
    // 경력월차 검증 (0 이상 11 이하의 정수)
    if (careerMonth < 0 || careerMonth > 11) {
      errorMessage = '경력월차는 0개월 이상 11개월 이하로 입력해주세요.';
      return false;
    }
    
    // 경력 기간이 0년 0개월인 경우 에러
    if (careerYear === 0 && careerMonth === 0) {
      errorMessage = '경력 기간을 입력해주세요.';
      return false;
    }

    // 추천자 이메일 유효성 검증 (선택사항이지만 입력된 경우)
    if (recommenderEmail) {
      const recommenderEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!recommenderEmailPattern.test(recommenderEmail)) {
        errorMessage = '추천자 이메일 형식이 올바르지 않습니다.';
        return false;
      }

      // 추천자 이메일과 본인 이메일 동일 체크
      if (recommenderEmail.toLowerCase() === email.toLowerCase()) {
        errorMessage = '추천자 이메일은 본인 이메일과 동일할 수 없습니다.';
        return false;
      }
    }

    errorMessage = '';
    return true;
  }
  
  // 회원가입 요청 처리
  async function handleSignup() {
    try {
      isLoading = true;
      
      // 서버로 회원가입 요청 보내기
      const response = await fetch(`${API_BASE_URL}/api/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          password,
          name,
          phone,
          birthDate,
          gender,
          educationLevel,
          careerYear,
          careerMonth,
          region: detailAddress || region, // 상세주소가 있으면 사용, 없으면 기존 거주지역 사용
          memberType,
          availableFrom,
          marketingConsent: acceptMarketing,
          zipcode,
          basicAddress,
          detailAddress,
          recommenderEmail
        })
      });
      
      // 응답 처리
      const data = await response.json();
      
      if (!response.ok) {
        errorMessage = data.error || '회원가입에 실패했습니다.';
        return;
      }
      
      // 회원가입 성공 시 토큰과 사용자 정보 저장
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      
      // 새 사용자 정보 저장 (3단계에서 사용)
      newUser = data.user;
      
      // 회원가입 완료 화면으로 이동
      step = 3;
      errorMessage = '';
    } catch (error) {
      console.error('회원가입 오류:', error);
      errorMessage = '서버 연결에 실패했습니다. 다시 시도해주세요.';
    } finally {
      isLoading = false;
    }
  }
  
  // 파일 업로드 성공 핸들러
  function handleFileUploadSuccess(event) {
    const { files, message } = event.detail;
    uploadedFiles = [...uploadedFiles, ...files];
    console.log('파일 업로드 성공:', files);
  }
  
  // 파일 삭제 핸들러
  function handleFileDelete(event) {
    const { file } = event.detail;
    uploadedFiles = uploadedFiles.filter(f => f.id !== file.id);
  }
  
  // 파일 업로드 건너뛰기
  function skipFileUpload() {
    setPage('login');
  }
  
  // 회원가입 완료
  function completeSignup() {
    if (uploadedFiles.length > 0) {
      alert(`${uploadedFiles.length}개의 파일이 성공적으로 업로드되었습니다.`);
    }
    setPage('login');
  }
</script>

<div class="centered-layout">
  <div class="centered-box max-w-3xl">
    <div class="logo">
      <h1>WIDE-WORK</h1>
    </div>
    
    <h2>회원가입</h2>
    
    <div class="signup-step">
      <span class="step {step >= 1 ? 'active' : ''}">1. 약관동의</span>
      <span class="step-divider">></span>
      <span class="step {step >= 2 ? 'active' : ''}">2. 정보입력</span>
      <span class="step-divider">></span>
      <span class="step {step >= 3 ? 'active' : ''}">3. 가입완료</span>
    </div>
    
    <!-- 커스텀 알럿으로 대체 -->
    <InfoModal
      bind:isOpen={alertOpen}
      message={alertMessage}
      type={alertType}
    />
    
    {#if step === 1}
      <!-- 약관동의 단계 -->
      <div class="terms-section">
        <div class="terms-header">
          <label class="checkbox-container">
            <input type="checkbox" 
                   checked={acceptTerms && acceptPrivacy && acceptMarketing}
                   on:change={(e) => toggleAllAgreements(e.target.checked)}>
            <span class="checkmark"></span>
            <span class="label-text">전체 동의</span>
          </label>
        </div>
        
        <div class="terms-list">
          <div class="terms-item">
            <label class="checkbox-container">
              <input type="checkbox" 
                     bind:checked={acceptTerms} 
                     on:change={(e) => acceptTerms = handleTermsCheck('terms', e.target.checked)}
                     disabled={!termsViewed}
                     required>
              <span class="checkmark"></span>
              <span class="label-text">[필수] 서비스 이용약관 동의</span>
            </label>
            <button class="btn btn-sm btn-primary" on:click={() => showTermsModal('terms')}>
              {termsViewed ? '다시 보기' : '보기'}
            </button>
          </div>
          
          <div class="terms-item">
            <label class="checkbox-container">
              <input type="checkbox" 
                     bind:checked={acceptPrivacy} 
                     on:change={(e) => acceptPrivacy = handleTermsCheck('privacy', e.target.checked)}
                     disabled={!privacyViewed}
                     required>
              <span class="checkmark"></span>
              <span class="label-text">[필수] 개인정보 수집 및 이용 동의</span>
            </label>
            <button class="btn btn-sm btn-primary" on:click={() => showTermsModal('privacy')}>
              {privacyViewed ? '다시 보기' : '보기'}
            </button>
          </div>
          
          <div class="terms-item">
            <label class="checkbox-container">
              <input type="checkbox" bind:checked={acceptMarketing}>
              <span class="checkmark"></span>
              <span class="label-text">[선택] 마케팅 정보 수신 동의</span>
            </label>
            <button class="btn btn-sm btn-primary" on:click={() => showTermsModal('marketing')}>보기</button>
          </div>
        </div>
      </div>
    {:else if step === 2}
      <!-- 정보입력 단계 -->
      <div class="signup-form">
        <div class="form-group">
          <label for="email" class="form-label required">이메일</label>
          <div class="input-group">
            <input 
              type="email" 
              id="email" 
              class="form-input"
              bind:value={email}
              placeholder="이메일 주소를 입력해주세요" 
              required
            >
            <Button 
              variant={isEmailDuplicated ? 'success' : 'primary'} 
              size="sm" 
              on:click={checkEmailDuplicate} 
              disabled={isLoading || !email || isEmailDuplicated}
            >
              {isEmailDuplicated ? '확인완료' : '중복확인'}
            </Button>
          </div>
          <small class="form-text">* 아이디 및 비밀번호 찾기 시 이용되니 정확한 이메일을 입력해주세요.</small>
        </div>
        
        <div class="form-group">
          <label for="password" class="form-label required">비밀번호</label>
          <input 
            type="password" 
            id="password"
            class="form-input"
            bind:value={password}
            placeholder="비밀번호를 입력해주세요" 
            required
          >
          <small class="form-text">* 영문, 숫자, 특수문자를 포함한 8~20자리</small>
        </div>
        
        <div class="form-group">
          <label for="password-confirm" class="form-label required">비밀번호 확인</label>
          <input 
            type="password" 
            id="password-confirm"
            class="form-input"
            bind:value={passwordConfirm}
            placeholder="비밀번호를 다시 입력해주세요" 
            required
          >
        </div>
        
        <div class="form-group">
          <label for="name" class="form-label required">이름</label>
          <input 
            type="text" 
            id="name"
            class="form-input"
            bind:value={name}
            placeholder="이름을 입력해주세요" 
            required
          >
        </div>
        
        <div class="form-group">
          <label for="birthDate" class="form-label required">생년월일</label>
          <input 
            type="date" 
            id="birthDate"
            class="form-input"
            bind:value={birthDate}
            required
          >
          <small class="form-text">* 만 14세 이상만 가입 가능합니다.</small>
        </div>
        
        {#if calculatedAge}
          <div class="form-group">
            <div class="form-label">나이 (자동 계산)</div>
            <div class="age-display">
              <span class="age-text">{calculatedAge}세</span>
            </div>
          </div>
        {/if}
        
        <!-- 성별 선택 -->
        <div class="form-group">
          <div class="form-label required">성별</div>
          <div class="form-input radio-group">
              <label class="radio-container">
                <input type="radio" name="gender" bind:group={gender} value="M" id="signup-gender-m">
                <span class="radio-custom"></span>
                <span class="label-text">남성</span>
              </label>
              <label class="radio-container">
                <input type="radio" name="gender" bind:group={gender} value="F" id="signup-gender-f">
                <span class="radio-custom"></span>
                <span class="label-text">여성</span>
              </label>
          </div>
        </div>
        
        <!-- 최종학력 선택 -->
        <div class="form-group">
          <div class="form-label required">최종학력</div>
          <div class="form-input radio-group">
            <label class="radio-container">
              <input type="radio" name="educationLevel" bind:group={educationLevel} value="highschool" required>
              <span class="radio-custom"></span>
              <span class="label-text">고등학교</span>
            </label>
            <label class="radio-container">
              <input type="radio" name="educationLevel" bind:group={educationLevel} value="associate">
              <span class="radio-custom"></span>
              <span class="label-text">전문학사</span>
            </label>
            <label class="radio-container">
              <input type="radio" name="educationLevel" bind:group={educationLevel} value="bachelor">
              <span class="radio-custom"></span>
              <span class="label-text">4년제학사</span>
            </label>
            <label class="radio-container">
              <input type="radio" name="educationLevel" bind:group={educationLevel} value="master">
              <span class="radio-custom"></span>
              <span class="label-text">석사이상</span>
            </label>
          </div>
        </div>
        
        <!-- 경력 기간 입력 (항상 표시) -->
        <div class="form-group">
          <div class="form-label required">경력 기간</div>
          <div class="form-input career-input-group">
            <div class="career-input-item">
              <input 
                type="number" 
                bind:value={careerYear}
                placeholder="0"
                min="0"
                max="50"
                required
              >
              <span class="career-unit">년</span>
            </div>
            <div class="career-input-item">
              <input 
                type="number" 
                bind:value={careerMonth}
                placeholder="0"
                min="0"
                max="11"
                required
              >
              <span class="career-unit">개월</span>
            </div>
          </div>
          <small class="form-text">* 경력 기간을 입력해주세요. (신입의 경우 0년 0개월)</small>
        </div>
        
        <!-- 주소 입력 -->
        <div class="form-group">
          <div class="form-label">주소 (00시 00구 00동 까지 작성)</div>
          <div class="address-input-group">
            <!-- 기본 주소 - 주석 처리
            <input
              type="text"
              id="basic-address"
              class="form-input"
              bind:value={basicAddress}
              placeholder="주소 검색을 클릭하여 기본 주소를 입력하세요"
              readonly
              on:click={openDaumPostcode}
            >
            -->

            <!-- 상세 주소 -->
            <input
              type="text"
              id="detail-address"
              class="form-input"
              bind:value={detailAddress}
              placeholder="예: 서울시 강남구 역삼동"
            >

            <!-- 우편번호와 주소찾기 버튼 - 주석 처리
            <div class="zipcode-input-group">
              <input
                type="text"
                id="zipcode"
                class="zipcode-input"
                bind:value={zipcode}
                placeholder="우편번호"
                readonly
              >
              <button class="address-search-btn" type="button" on:click={openDaumPostcode}>
                주소 검색
              </button>
            </div>
            -->
          </div>
        </div>
        
        <div class="form-group">
          <label for="phone" class="form-label required">휴대폰 번호</label>
          <input 
            type="tel" 
            id="phone"
            class="form-input"
            bind:value={phone}
            placeholder="'-' 없이 입력해주세요" 
            required
          >
        </div>
        
        <div class="form-group">
          <label for="availableFrom" class="form-label">투입가능일자 (선택사항)</label>
          <input
            type="date"
            id="availableFrom"
            class="form-input"
            bind:value={availableFrom}
          >
          <small class="form-text">* 프로젝트 투입이 가능한 날짜를 선택해주세요.</small>
        </div>

        <!-- 추천자 이메일 -->
        <div class="form-group">
          <label for="recommender-email" class="form-label">추천자 이메일 (선택사항)</label>
          <input
            type="email"
            id="recommender-email"
            class="form-input"
            bind:value={recommenderEmail}
            placeholder="추천인의 이메일 주소를 입력해주세요"
          >
          <small class="form-text">* 본인을 추천해준 분의 이메일 주소를 입력해주세요. (선택사항)</small>
        </div>
        
      </div>
    {:else if step === 3}
      <!-- 가입완료 단계 -->
      <div class="signup-complete">
        <div class="complete-icon">✓</div>
        <h3>회원가입이 완료되었습니다!</h3>
        <p>{newUser?.name || ''}님, 환영합니다!</p>
        
        <!-- 파일 업로드 섹션 -->
        <div class="file-upload-section">
          <h4>추가 정보 등록 (선택사항)</h4>
          <p class="upload-description">
            이력서, 포트폴리오, 자격증 등을 업로드하면<br>
            더 나은 프로젝트 매칭 기회를 받을 수 있습니다.
          </p>
          
          <div class="form-group">
            <FileUpload
              fileType="signup"
              label="첨부파일 업로드"
              description="PDF, DOC, DOCX, JPG, PNG 파일을 업로드할 수 있습니다."
              maxFiles={5}
              existingFiles={uploadedFiles}
              on:upload-success={handleFileUploadSuccess}
              on:delete-file={handleFileDelete}
            />
          </div>
          
          <div class="upload-actions">
            <Button variant="secondary" on:click={skipFileUpload}>
              나중에 하기
            </Button>
            <Button variant="primary" on:click={completeSignup}>
              완료하기
            </Button>
          </div>
        </div>
      </div>
    {/if}
    
    {#if step < 3}
      <div class="d-flex justify-content-center gap-3">
        <Button variant="secondary" on:click={goToPrevStep}>
          {step === 1 ? '취소' : '이전'}
        </Button>
        
        <Button 
          variant="primary"
          loading={isLoading}
          on:click={goToNextStep}
          disabled={isLoading}
        >
          {isLoading ? '처리중...' : step === 1 ? '다음' : '가입하기'}
        </Button>
      </div>
    {/if}
  </div>
</div>

<!-- 약관 모달 -->
<BaseModal 
  bind:isOpen={showModal} 
  title={modalTitle}
  size="lg"
  on:close={closeModal}
>
  <div class="modal-body">
    <pre>{modalContent}</pre>
  </div>
</BaseModal>

<style>
  .logo {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .logo h1 {
    color: #3273dc;
    font-size: 2.2rem;
    font-weight: 700;
  }
  
  h2 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 30px;
  }
  
  .signup-step {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
  
  .step {
    padding: 8px 15px;
    font-size: 0.9rem;
    color: #999;
  }
  
  .step.active {
    color: #3273dc;
    font-weight: 500;
  }
  
  .step-divider {
    color: #ccc;
    margin: 0 5px;
  }
  
  .terms-section {
    margin-bottom: 30px;
    border: 1px solid #eee;
    border-radius: 5px;
  }
  
  .terms-header {
    padding: 15px;
    border-bottom: 1px solid #eee;
  }
  
  .terms-list {
    padding: 15px;
  }
  
  .terms-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .terms-item:last-child {
    margin-bottom: 0;
  }
  
  .checkbox-container {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    font-size: 1rem;
    user-select: none;
  }
  
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  
  .checkmark {
    height: 20px;
    width: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin-right: 10px;
  }
  
  .checkbox-container:hover input ~ .checkmark {
    border-color: #3273dc;
  }
  
  .checkbox-container input:checked ~ .checkmark {
    background-color: #3273dc;
    border-color: #3273dc;
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .checkbox-container .checkmark:after {
    left: 7px;
    top: 3px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  
  .label-text {
    font-size: 0.95rem;
  }
  
  .signup-form {
    margin-bottom: 30px;
  }
  
  .radio-group {
    display: flex;
    gap: 20px;
    align-items: center;
    padding: 0 10px;
    flex-wrap: wrap;
  }
  
  /* 최종학력 라디오 그룹은 가로로 정렬하되 줄바꿈 허용 */
  .form-group:has([name="educationLevel"]) .radio-group {
    flex-direction: row;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
  }
  
  .radio-container {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    font-size: 1rem;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  
  .radio-custom {
    height: 18px;
    width: 18px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;
  }
  
  .radio-container:hover input ~ .radio-custom {
    border-color: #3273dc;
  }
  
  .radio-container input:checked ~ .radio-custom {
    background-color: #fff;
    border-color: #3273dc;
  }
  
  .radio-custom:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .radio-container input:checked ~ .radio-custom:after {
    display: block;
  }
  
  .radio-container .radio-custom:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #3273dc;
  }
  
  .signup-complete {
    text-align: center;
    padding: 40px 0;
  }
  
  .complete-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background-color: #3273dc;
    color: white;
    font-size: 2.5rem;
    border-radius: 50%;
    margin-bottom: 20px;
  }
  
  .signup-complete h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
  }
  
  .signup-complete p {
    color: #666;
    font-size: 1.1rem;
    margin-bottom: 30px;
  }
  
  /* 파일 업로드 섹션 스타일 */
  .file-upload-section {
    max-width: 500px;
    margin: 0 auto;
    text-align: left;
  }
  
  .file-upload-section h4 {
    font-size: 1.3rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    text-align: center;
  }
  
  .upload-description {
    color: #666;
    font-size: 0.95rem;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 25px;
  }
  
  .upload-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 25px;
  }
  
  
  /* 모달 스타일은 modals.css에서 상속 */
  
  .checkbox-container input:disabled ~ .checkmark {
    background-color: #f0f0f0;
    border-color: #ccc;
    cursor: not-allowed;
  }
  
  /* 나이 표시 스타일 */
  .age-display {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 5px;
  }
  
  .age-text {
    font-size: 1rem;
    font-weight: 500;
    color: #3273dc;
  }
  
  /* 경력 입력 그룹 스타일 */
  .career-input-group {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .career-input-item {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .career-input-item input {
    width: 80px;
    text-align: center;
  }

  .career-unit {
    font-size: 0.9rem;
    color: #666;
    font-weight: 500;
  }

  /* 주소 입력 그룹 스타일 */
  .address-input-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .zipcode-input-group {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .zipcode-input {
    width: 100px;
    flex-shrink: 0;
    height: 40px;
  }

  .zipcode-input:read-only {
    background-color: #f8f9fa;
    cursor: not-allowed;
  }

  .address-search-btn {
    height: 40px;
    padding: 0 16px;
    background-color: #3273dc;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .address-search-btn:hover {
    background-color: #2366c1;
  }

  .address-search-btn:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.3);
  }

  #basic-address:read-only {
    background-color: #f8f9fa;
    cursor: not-allowed;
    height: 40px;
  }

  #detail-address {
    height: 40px;
  }
</style> 